<template>
    <svg :width="size" :height="size" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2"
        stroke-linecap="round" stroke-linejoin="round"
        aria-hidden="true">
        <path d="M21.21 15.89A10 10 0 1 1 8 2.83" />
        <path d="M22 12A10 10 0 0 0 12 2v10z" />
    </svg>
</template>

<script>
// Pie chart icon (feather-icons style). Usado como marcador de "sección con
// datos agregados / breakdown". Hereda color via currentColor — el parent lo
// pinta con --report-text o el tono que corresponda.
export default {
    name: "PieChartIcon",
    props: {
        size: { type: [Number, String], default: 16 },
    },
};
</script>
